//@flow
import React from "react";
//$FlowFixMe
import css from "./radioplayer.module.scss";
import moment from "moment";
class Footer extends React.PureComponent<*, *> {
  render(): Object {
    return (
      <React.Fragment>
        <div className={css.footer}>
          Designed and built by Chris Rudall for In Demand Digital. For more information please email support@indemand.digital
          <br />
          Copyright In Demand Radio Ltd{" "}
          <span
            onClick={() => {
              localStorage.setItem("betaMode", "1");
              window.location.reload();
            }}
          >
            &copy;
          </span>{" "}
          2018-{moment().format("YYYY")}
        </div>
        {localStorage.getItem("betaMode") === "1" ? (
          <div
          style={{cursor:"pointer"}}
            onClick={() => {
              localStorage.setItem("betaMode", "0");
              window.location.reload();
            }}
          >
            EXIT BETA MODE
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}
export default Footer;
